import type { ReactElement } from 'react'

import { useOptionalOpenHelpContact } from '../../modules/support/shared/help-contact-dialog/help-contact-hooks.ts'

import { GenericProblemMessage } from './generic-problem-message.tsx'

export function TemporaryFailureScreen(): ReactElement {
  const openHelpContact = useOptionalOpenHelpContact() ?? openSupportEmail
  return (
    <GenericProblemMessage
      title="Problème technique temporaire"
      principalMessage="Désolé, un problème technique nous empêche de continuer."
      firstSubText="Ce problème est temporaire, il peut être résolu en réessayant plus tard, ou en rafraîchissant la page."
      secondSubText="Vous pouvez également nous contacter pour toute question."
      buttonText="Contacter le support"
      onButtonClick={openHelpContact}
      secondaryButtonText="Réessayer"
      onSecondaryButtonClick={() => window.location.reload()}
    />
  )
}

function openSupportEmail(): void {
  window.location.assign('mailto:support@orus.eu')
}
